import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { FulfillHardgoodsRow } from "~fulfill/product/hardgoods/types";

import isRecord from "~/helpers/isRecord";
import { HARDGOOD_STOCK_TARGET_KIND } from "~fulfill/inventory/stock/helpers/hardgoodStockScope";

const HARDGOOD_SOURCE_KIND = "hardgood";

const HARDGOODS_PATH = "/fulfill/product/hard-goods";

export interface HardgoodSourceCheckpoint {
	materialItemId: string;
	materialItemName: string;
	searchText: string;
}

const isHardgoodSourceCheckpoint = (value: unknown): value is HardgoodSourceCheckpoint =>
	isRecord(value) &&
	typeof value.materialItemId === "string" &&
	typeof value.materialItemName === "string" &&
	typeof value.searchText === "string";

const hasStockToOpen = (row: FulfillHardgoodsRow): boolean => row.binCount > 0;

const hardgoodStockHop = (
	row: FulfillHardgoodsRow,
	searchText: string
): [HardgoodSourceCheckpoint, ContinuationTarget] => [
	{ materialItemId: row.id, materialItemName: row.name, searchText },
	{ targetId: row.id, targetKind: HARDGOOD_STOCK_TARGET_KIND }
];

const hardgoodEditorKey = (materialItemId: string): string => `hardgood:${materialItemId}`;

const hardgoodContinuation = {
	HARDGOOD_SOURCE_KIND,
	HARDGOODS_PATH,
	hardgoodEditorKey,
	hardgoodStockHop,
	hasStockToOpen,
	isHardgoodSourceCheckpoint
} as const;

export default hardgoodContinuation;
